<template>
  <section class="tenant-main-shell">
    <slot name="breadcrumb" />
    <div class="tenant-page-shell">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'TenantMainShell'
}
</script>
